import VueApollo from 'vue-apollo'
import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { HttpLink } from 'apollo-link-http'
import { split } from 'apollo-link'

const hasuraUrl = process.env.VUE_APP_HASURA_URL
let httpUri = `https://${hasuraUrl}/graphql`
let wsUri = `wss://${hasuraUrl}/graphql`
const httpLink = new HttpLink({
  uri: httpUri,
  headers: { // 配置headers
    'x-hasura-admin-secret': '' // hasura数据库查看
  }
})

const wsLink = new WebSocketLink({
  uri: wsUri,
  options: {
    lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: { // 配置headers
      headers: {
        'x-hasura-admin-secret': ''
      }
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
export default apolloProvider
